// Global, all-time figures from Product's "Quick Facts - simplified by service type / pet type"
// sheet. Numbers are raw and formatted for the active locale at render time; "%" stays in the
// translated message.
export const SERVICE_LANDING_QUICK_FACT_STATS = {
  overnightDogs: 4_700_000,
  overnightDogSittersPct: 95.3,
  overnightCats: 1_900_000,
  overnightCatSittersPct: 93.4,
  overnightPets: 4_900_000,
  overnightPetSittersPct: 95.4,
  dropInDogs: 1_800_000,
  dropInDogParents: 870_000,
  dropInCats: 1_600_000,
  dropInCatParents: 780_000,
  dropInPets: 3_500_000,
  dropInPetParents: 1_500_000,
  houseSittingPets: 2_400_000,
  houseSittingSittersPct: 94.1,
  trainingDogs: 13_000,
  trainingTrainers: 3_500,
  dayCareDogs: 1_100_000,
  dayCareSpots: 1_000_000,
  walkingDogs: 1_300_000,
  walkingSameWalkerPct: 24.2,
} as const;
